import { createAsyncThunk, createAction } from "@reduxjs/toolkit";
import axios from "../../utils/axios";
import { IDeleteApiResponse, IError, apiLimit } from "../../utils/api.types";

import {
    Employees,
    EmployeeFormInputs,
    EmployeeResponse,
    Employee,
    EmployeeUpdatePayload,
    EmployeeAccountResponse,
    EmployeeFetch,
    EmployeeSeqNumber,
} from "../../utils/employee.types";

// Fetch InvoiceSeqNumber async thunk.
export const fetchEmployeeSeqNumber = createAsyncThunk(
    'employee/fetchEmployeeSeqNumber', 
    async (voucherType: string): Promise<EmployeeSeqNumber> => {
        const response = await axios.get(`/api/v1/employee/emp-seq-number?voucherType=${voucherType}`);
        return response.data
    }
);

//Add Employee async Thunk.
 export const addEmployee = createAsyncThunk(
  'employee/addInventory',
  async (employeePayload: any): Promise<any> => {
      const response = await axios.post(`/api/v1/employee`, employeePayload);

      return response.data
  }
);


/**
 * Fetch Employees async thunk.
*/
export const fetchEmployees = createAsyncThunk(
    'employee/fetchEmployees',
    async ({accountId, type, params} : EmployeeFetch): Promise<Employees> => {
        let queryParam = (params)? `${params}`: ''
        const response = await axios.get(`/api/v1/employee/account/${accountId}/emp-list?${queryParam}`);
        return response.data;
    }
);

export const selectedEmployeeID = createAction("employee/selectedEmployeeID", (employeeId) => {
    return {
        type: 'employee/selectedEmployeeID',
        payload: employeeId
    }
});


/**
 * Update Employee async Thunk.
 */
// export const updateEmployee = createAsyncThunk(
//     'employee/updateEmployee',
//     async ({ id, employeePayload }: any, thunkApi) => {
//         try {
//             const response = await axios.put(`/api/v1/employee/${id}`, employeePayload);

//             const { data } = response;

//             if (response.status === 200) {
//                 return data;
//             }

//             return thunkApi.rejectWithValue(data.error);
//         } catch (error: any) {
//             return thunkApi.rejectWithValue(error.response.data);
//         }
//     }
// );

export const updateEmployee = createAsyncThunk(
    'employee/updateEmployee',
    async ({id, employeePayload}: EmployeeUpdatePayload): Promise<any> => {
        const response = await axios.put(`/api/v1/employee/${id}`, employeePayload);
        return response.data;
    }
);

export const deleteEmpAttachment = createAsyncThunk(
    'employee/deleteEmpAttachment',
    async ({id, employeePayload}: EmployeeUpdatePayload): Promise<any> => {
        const response = await axios.put(`/api/v1/employee/${id}/deleteEmpAttachment`, employeePayload);
        console.log(response);
        return response.data;
    }
);


/**
 * Fetch Employees async thunk.
*/
export const fetchEmployeeByAccountId = createAsyncThunk(
    'employee/fetchEmployeeByAccountId',
    async (id: string): Promise<Employee> => {
        const response = await axios.get(`/api/v1/employee/account/${id}`);
        return response.data.employee;
    }
);

/**
 * Fetch Inventory By UD async thunk.
*/

export const fetchEmployeeById = createAsyncThunk(
    'employee/fetchEmployeeById',
    async (id: string): Promise<Employee> => {
        const response = await axios.get(`/api/v1/employee/${id}`);
        return response.data;
    }
);

/**
 * Delete Inventories async Thunk.
 */
export const deleteEmployee = createAsyncThunk(
    'inventory/deleteInventory',
    async (id: string): Promise<IDeleteApiResponse> => {
        const response = await axios.delete(`/api/v1/employee/${id}`);

        response.data['id'] = id;

        return response.data
    }
);


// Employee Invitation Thunks

/**
 * Fetch employees without user access for invitation
 */
export const fetchEmployeesWithoutAccess = createAsyncThunk(
    'employee/fetchEmployeesWithoutAccess',
    async (): Promise<any> => {
        const response = await axios.get('/api/v1/employee/without-access');
        return response.data;
    }
);

/**
 * Invite employee to create user account
 */
export const inviteEmployee = createAsyncThunk(
    'employee/inviteEmployee',
    async ({ employeeId, roleId, welcomeMessage }: { 
        employeeId: string, 
        roleId: string, 
        welcomeMessage: string 
    }): Promise<any> => {
        const response = await axios.post(`/api/v1/employee/${employeeId}/invite`, {
            roleId,
            welcomeMessage
        });
        return response.data;
    }
);

/**
 * Fetch pending employee invitations
 */
export const fetchPendingInvitations = createAsyncThunk(
    'employee/fetchPendingInvitations',
    async (departmentId?: string): Promise<any> => {
        const params = departmentId ? `?departmentId=${departmentId}` : '';
        const response = await axios.get(`/api/v1/employee/invitations/pending${params}`);
        return response.data;
    }
);

/**
 * Resend employee invitation
 */
export const resendInvitation = createAsyncThunk(
    'employee/resendInvitation',
    async (invitationId: string): Promise<any> => {
        const response = await axios.post(`/api/v1/employee/invitations/${invitationId}/resend`);
        return response.data;
    }
);

/**
 * Cancel employee invitation
 */
export const cancelInvitation = createAsyncThunk(
    'employee/cancelInvitation',
    async (invitationId: string): Promise<any> => {
        const response = await axios.put(`/api/v1/employee/invitations/${invitationId}/cancel`);
        return response.data;
    }
);

/**
 * Accept employee invitation (public endpoint)
 */
export const acceptInvitation = createAsyncThunk(
    'employee/acceptInvitation',
    async ({ token, password, profilePic }: { 
        token: string, 
        password: string, 
        profilePic?: string 
    }): Promise<any> => {
        const response = await axios.post(`/api/v1/employee/invitations/${token}/accept`, {
            password,
            profilePic
        });
        return response.data;
    }
);

/**
 * Update Employee Status (Activate/Deactivate) async thunk.
 */
export const updateEmployeeStatus = createAsyncThunk(
    'employee/updateStatus',
    async ({ id, isActive }: { id: string; isActive: boolean }): Promise<any> => {
        const response = await axios.put(`/api/v1/employee/${id}/status`, { isActive });
        return response.data;
    }
);

